import {
  Component,
  OnInit,
  Output,
  ViewEncapsulation,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  BankAccount,
  BankAccountService,
  EnumService,
  LocalStorageService,
} from '@ops/shared-types';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { OpsSelectComponent } from '../ops-select/ops-select.component';
import { OpsCalendarComponent } from '../ops-calendar/ops-calendar.component';
import { OpsCheckboxComponent } from '../ops-checkbox/ops-checkbox.component';

/**
 * inputs:
 * -------
 * input label?: string
 * input placeholder?: string
 * input mandatory?: boolean
 * input formName?: string
 * input type text|email|phone|credit-card|cvc|password|custom
 * input customValidation? regexp|method
 * input noteText?: string
 * input isDisabled?: boolean
 * input setFocus?: boolean
 * input errorMessage?: string
 * input showError?: boolean
 * ---------------------------
 * events:
 * -------
 * output focused
 * output blured
 * output clicked
 * output changed
 * output validationError
 */

const BankAccountDefault = {
  IBAN: '',
  SWIFT: '',
  address: '',
  bankName: '',
  branchName: '',
  company: '',
  startDate: null,
  createdAt: '',
  currencyCode: '',
  deletedAt: '',
  endDate: '',
  fundedFrom: '',
  startingBalance: 0,
  description: '',
  startingBalanceDate: null,
  correspondentBank: '',
  correspondentSWIFT: '',
  isDebit: '',
  isFavorite: false,
  shortName: '',
};

@Component({
  selector: 'ops-bank-account-create',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    OpsInputComponent,
    OpsSelectComponent,
    OpsCheckboxComponent,
    OpsCalendarComponent,
  ],
  templateUrl: './ops-bank-account-create.component.html',
  styleUrl: './ops-bank-account-create.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class OpsBankAccountCreateComponent implements OnInit {
  bankAccount = {
    IBAN: '',
    SWIFT: '',
    address: '',
    bankName: '',
    branchName: '',
    company: '',
    startDate: null,
    createdAt: '',
    currencyCode: '',
    deletedAt: '',
    endDate: '',
    fundedFrom: '',
    isDebit: '',
    startingBalance: 0,
    description: '',
    startingBalanceDate: null,
    correspondentBank: '',
    correspondentSWIFT: '',
    isFavorite: false,
    shortName: '',
  };

  mainCurrencies = [];
  errorsTrack = {
    shortName: 'This field is required',
    description: 'This field is required',
    bankName: 'This field is required',
    branchName: 'This field is required',
    SWIFT: 'This field is required',
    IBAN: 'This field is required',
  };

  @Output() closeModal = new EventEmitter<boolean | null>();

  constructor(
    private ls: LocalStorageService,
    private bankService: BankAccountService,
    private enumService: EnumService
  ) {}

  ngOnInit(): void {
    this.errorsTrack = {
      shortName: 'This field is required',
      description: 'This field is required',
      bankName: 'This field is required',
      branchName: 'This field is required',
      SWIFT: 'This field is required',
      IBAN: 'This field is required',
    };
    this.mainCurrencies = this.enumService
      .getCurrencyOptionsDetailed()
      .map((cop: any) => {
        return { key: cop.name, value: cop.shortName };
      });
  }

  onSelectChangeForBA(value: string, field: string) {
    this.bankAccount[field] = value;
  }

  get isValid(): boolean {
    if (Object.keys(this.errorsTrack).length) {
      return false;
    }
    if (!this.bankAccount.startDate) {
      return false;
    }
    if (!this.bankAccount.currencyCode) {
      return false;
    }

    return true;
  }

  closeModalHandle = () => {
    this.closeModal.emit();
  };

  datePreview = (val: Date) => {
    const dateCover = val.getDate();
    const monthCover = val.getMonth() + 1;

    return (
      (dateCover < 10 ? '0' + dateCover : dateCover) +
      '.' +
      (monthCover < 10 ? '0' + monthCover : monthCover) +
      '.' +
      val.getFullYear()
    );
  };

  onValueChange(selectValue: string, field?: string): void {
    this.bankAccount[field] = selectValue;
  }

  saveNewBankAccount() {

    

    const bankAccountClean = {
      ...this.bankAccount,
    };

    bankAccountClean.startingBalanceDate =
    this.bankAccount.startingBalanceDate === ''
      ? null
      : this.bankAccount.startingBalanceDate;

    delete bankAccountClean.endDate;
    delete bankAccountClean.deletedAt;
    delete bankAccountClean.createdAt;
    delete bankAccountClean.company;
    delete bankAccountClean.fundedFrom;
    delete bankAccountClean.isDebit;

    this.bankService
      .createBankAccount(bankAccountClean, this.ls.getCurrentCompany()?._id)
      .subscribe(async (newBank: BankAccount) => {
        // console.log('NEW BANK ACC', newBank);
        await this.enumService.refreshCache(this.ls.getCurrentCompany()._id);
        this.closeModal.emit(true);
      });
  }

  onErrorHandler(error: string, field?: string) {
    if (!error || error === '') {
      delete this.errorsTrack[field];
    } else {
      this.errorsTrack[field] = error;
    }
  }
}
